export const AppConfig = {
  base_url: {
    api: "https://serviceprovider.1superapp.com/app",
    // api: "https://serviceprovider.1superapp.com/app_test",

    superapp: "https://",
  },
  user_agent: {
    superapp: {
      android: "",
      ios: "",
    },
  },
};
